import React, { useState } from "react";
import classNames from "classnames";

const Switcher = ({ was, became }) => {
  const [beforeCurrent, setBeforeCurrent] = useState(false);

  return (
    <div
      className={classNames("before-after", {
        curt: beforeCurrent,
      })}
    >
      <img src={`${was.imageUrl}`} alt={was.alt} />
      <img src={`${became.imageUrl}`} alt={became.alt} />

      <span className="switcher">
        <span
          className={classNames("switcher-item", {
            active: beforeCurrent,
          })}
          onClick={() => {
            setBeforeCurrent(true);
          }}
        >
          Было
        </span>

        <span
          className={classNames("switcher-item", {
            active: !beforeCurrent,
          })}
          onClick={() => {
            setBeforeCurrent(false);
          }}
        >
          Стало
        </span>
      </span>
    </div>
  );
};

export default Switcher;
